module.exports = __webpack_public_path__ + "img/rules-icon.043d7ea.svg";